import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setPassangerWheelChairIndex } from "./reviewbookingSlice";
import { groupSSRBySegment } from "../../_helpers/ssrUtils";
import { formatIndianNumber } from "../../_helpers/formatUtils";

const WheelChairSelection = ({
  flightReviewDetails,
  travellers,
  selectedWheelChairPerSegment,
  toggleWheelChairSelection,
}: {
  flightReviewDetails: any;
  travellers: any[];
  selectedWheelChairPerSegment: {
    [segmentIndex: number]: { [passengerIndex: number]: any };
  };
  toggleWheelChairSelection: (
    ssr: any,
    passengerIndex: number,
    segmentIndex: number
  ) => void;
}) => {
  const dispatch = useAppDispatch();
  const passangerWheelChairIndex = useAppSelector(
    (state) => state.reviewbooking.passangerWheelChairIndex
  );

  const routewiseSegmentArray = flightReviewDetails.flatMap(
    (e: any) => e.Flight?.Segments
  );

  const ssrData = useAppSelector((state) => state.reviewbooking.ssrData);

  const segmentWiseSSR = groupSSRBySegment(ssrData);

  return (
    <>
      <div className="seat-slection-title ssr-slection-title">
        <h4 className="m-0 passanger-tabs">
          {travellers.map((traveller, i) => {
            const wheelchairCount = Object.keys(
              selectedWheelChairPerSegment?.[i] || {}
            ).length;

            const totalWheelChairAmount = Object.values(
              selectedWheelChairPerSegment?.[i] || {}
            ).reduce(
              (acc: number, ssr: any) => acc + (ssr?.Total_Amount || 0),
              0
            );

            return (
              <span
                className={`title-passanger-name ${
                  i === passangerWheelChairIndex ? "active" : ""
                }`}
                onClick={() => dispatch(setPassangerWheelChairIndex(i))}
              >
                {`${traveller?.initial} ${traveller?.first_name}  ${
                  traveller?.last_name
                }(${wheelchairCount} WheelChair - ₹ ${formatIndianNumber(
                  totalWheelChairAmount
                )})`}
              </span>
            );
          })}
        </h4>
      </div>
      {travellers.map((traveller, passengerIndex) => {
        if (passengerIndex !== passangerWheelChairIndex) return null;

        return (
          <Swiper
            key={passengerIndex}
            slidesPerView="auto"
            spaceBetween={30}
            pagination={{ clickable: true }}
            navigation
            modules={[Navigation]}
            allowTouchMove={false}
            className="ssr-slider"
          >
            {segmentWiseSSR?.map((ssrDetails: any, segmentIndex: number) => {
              const totalSegment = segmentWiseSSR?.length;

              const selectedWheelChair =
                selectedWheelChairPerSegment?.[passengerIndex]?.[segmentIndex];
              const wheelchairAmount = selectedWheelChair?.Total_Amount || 0;

              const wheelchairArray = ssrDetails?.SSRDetails?.filter(
                (e: any) => e?.SSR_Type === 10
              );

              return (
                <SwiperSlide
                  key={segmentIndex}
                  className={totalSegment === 1 ? "one-slide" : "multi-slide"}
                >
                  <div
                    className="w-100"
                    style={{
                      backgroundColor: "white",
                      boxShadow: "0 0 5px #00000026",
                      borderRadius: "5px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      className="p-2 w-100"
                      style={{ borderBottom: "1px solid lightgray" }}
                    >
                      <div className="route-seat-selection-title">
                        <h4 className="m-0">
                          {routewiseSegmentArray[segmentIndex]?.Origin_City} →{" "}
                          {
                            routewiseSegmentArray[segmentIndex]
                              ?.Destination_City
                          }
                        </h4>
                        <span
                          className={`m-0 ${
                            !selectedWheelChair
                              ? "pending-selection"
                              : "seat-amount"
                          }`}
                        >
                          {!selectedWheelChair
                            ? "Selection pending"
                            : "₹ " + formatIndianNumber(wheelchairAmount)}
                        </span>
                      </div>
                      <div className="route-seat-selection-title">
                        <span className="m-0">
                          {selectedWheelChair ? "1" : "No"} WheelChair Selected
                        </span>
                        {selectedWheelChair && (
                          <span className="m-0">Added to fare</span>
                        )}
                      </div>
                    </div>

                    <div className="position-relative">
                      <div className="grid grid-cols-12 main-ssrselection-layout">
                        <div className="space-y-2 col-span-12">
                          {wheelchairArray?.length > 0 ? (
                            wheelchairArray?.map((ssr: any) => {
                              const isSelected =
                                selectedWheelChair?.SSR_Key === ssr.SSR_Key;

                              return (
                                <div
                                  className="flight-card mb-4"
                                  key={ssr.SSR_Key}
                                >
                                  <div className="flight-info">
                                    <h3 className="flight-title">
                                      {/* {ssr.SSR_TypeName} */}
                                      {ssr.SSR_TypeDesc}
                                    </h3>
                                    {/* <p className="flight-description">
                                      {ssr.SSR_TypeDesc}
                                    </p> */}
                                    <span className="ssr-price">
                                      ₹ {formatIndianNumber(ssr.Total_Amount)}
                                    </span>
                                  </div>

                                  <button
                                    type="button"
                                    className={`flight-select-btn ${
                                      isSelected ? "selected" : ""
                                    }`}
                                    onClick={() =>
                                      toggleWheelChairSelection(
                                        ssr,
                                        passengerIndex,
                                        segmentIndex
                                      )
                                    }
                                  >
                                    {isSelected ? "Selected" : "Select"}
                                  </button>
                                </div>
                              );
                            })
                          ) : (
                            <h4 className="text-center">
                              Wheel Chair selection is unavailable for this
                              segment
                            </h4>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        );
      })}
    </>
  );
};

export default WheelChairSelection;
